import { render, staticRenderFns } from "./StaticPagesList.vue?vue&type=template&id=301fe0f8&scoped=true"
import script from "./StaticPagesList.vue?vue&type=script&lang=js"
export * from "./StaticPagesList.vue?vue&type=script&lang=js"
import style0 from "./StaticPagesList.vue?vue&type=style&index=0&id=301fe0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301fe0f8",
  null
  
)

export default component.exports